import {Spinner} from '@mintdata-wsp/common/components/spinner/Spinner';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';
import {SidebarLink} from './SidebarLink';
import {WspSidebarLink} from './WspSidebar';

const styles = require('./CurrentUsage.less');
const cx = classnames.bind(styles);

interface Props
{
}

@observer
export class CurrentUsage extends React.Component<Props, any>
{
    render():JSX.Element
    {
        const {userDesignCount, publishedApps} = rootState.data;

        return (
            <div className={cx(styles.wrapper)}>

                <SidebarLink
                    sidebarLink={WspSidebarLink.CURRENT_USAGE}
                    className={styles.linkBold}
                    iconClassName={styles.linkIcon}
                />

                <div className={styles.content}>
                    <div className={styles.applications}>
                        {publishedApps
                            ? `${publishedApps.length} application${publishedApps.length != 1 ? 's' : ''}`
                            : <Spinner />
                        }
                    </div>
                    <div className={styles.designs}>
                        {userDesignCount !== null
                            ? `${userDesignCount} design${userDesignCount != 1 ? 's' : ''}`
                            : <Spinner />
                        }
                    </div>
                </div>

                {/*<WSPButton*/}
                {/*    className={styles.btnUpgrade}*/}
                {/*    caption={'Upgrade'}*/}
                {/*    style={ButtonStyle.Raised}*/}
                {/*    size={ButtonSize.Large}*/}
                {/*/>*/}

            </div>
        );
    }
}
